var URL = window.URL || window.webkitURL;


var puzzlePersonnalisePage = {

    $page: $('.puzzle-personnalise-page'),
    $cropperWrapper: $('.cropper-wrapper'),
    $placeholderDiv: null,
    $progressDiv: null,
    $img: null,
    cropper: null,

    imageInfos: {},
    selectionInfos: {},
    minimumSize: {},
    // imgWidth: null,
    // imgHeight: null,

    idPhoto: null,

    originalImageURL: null,
    // uploadedImageType: 'image/jpeg',
    // uploadedImageName: 'cropped.jpg',
    // uploadedImageURL: null,


    init: function () {
        var $this = this;
        if (this.$page.length <= 0) {
            return;
        }

        this.$img = this.$cropperWrapper.find('img');
        this.$placeholderDiv = this.$cropperWrapper.find('.placeholder');
        this.$progressDiv = this.$cropperWrapper.find('.progress-div');
        this.originalImageURL = this.$img.attr('src');

        this.setListeners();
        this.initCropper();
        // // Get the Cropper.js instance after initialized
        // var cropper = $image.data('cropper');
    },

    scrollListToActiveElement: function () {
        $accordion = $('.accordion-model');
        var elementTop = $accordion[0].offsetTop;
        var divTop = $accordion.find('.active').parent()[0].offsetTop;
        var elementRelativeTop = elementTop - divTop;

        // $accordion.scrollTop(Math.abs(elementRelativeTop) -50);
        $accordion.animate({scrollTop: Math.abs(elementRelativeTop) - 50}, 300);
    },

    setListeners: function () {
        var $this = this;

        $('[data-toggle="collapse"]').on('click', function (e) {

            // Désactive l'ouverture sur un heading disabled
            if ($(this).hasClass('disabled')) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            // Place la liste déroulante au bon endroit après ouverture de l'accordion
            if ($(this).hasClass('collapsed') && $(this).filter('[data-target="#accordion-model"]').length) {
                setTimeout(function () {
                    $this.scrollListToActiveElement();
                }, 100);
            }

        });


        // Déclenchement du bouton d'upload au clic sur le bouton dans la buybox
        this.$page.on('click', '.change-photo', function (e) {
            e.preventDefault();
            $this.$cropperWrapper.find('input[type="file"]').trigger('click');
        });

        // Déclenchement du bouton d'upload au clic sur le bouton dans la buybox
        this.$page.on('click', 'button.addToCart:not([disabled])', function (e) {
            e.preventDefault();
            $this.validImageSelection();
        });


        // Activation du modèle ou de l'orientation cliquée
        $optionButtons = $('.accordion-model, .accordion-orientation').find('.puzzle-personnalise-button');
        $optionButtons.on('click', function (e) {
            e.preventDefault();

            $(this).closest('.accordion').find('.puzzle-personnalise-button').removeClass('active');
            $(this).addClass('active');

            $this.editDisplayedActivePuzzleInfos();
            $this.updateCropperRatio();
        });

        // Activation du modèle cliqué
        // $orientationButtons = $('.accordion-model .puzzle-personnalise-button');
        // $modelButtons.on('click', function (e) {
        //     e.preventDefault();
        //
        //     $modelButtons.removeClass('active');
        //     $(this).addClass('active');
        //
        //     $this.updateCropperRatio();
        // });


        this.setImportImageListener();
    },

    initCropper: function () {
        var $this = this;
        this.$img.cropper('destroy');

        this.$img.cropper({
            aspectRatio: 1,
            viewMode: 2,
            preview: '.img-preview',
            zoomable: false,
            zoomOnWheel: false,
            zoomOnTouch: false,
            crop: $.proxy($this.updateCoordinates, $this)
        });

        this.cropper = this.$img.data('cropper');

        this.updateCropperRatio();
    },

    updateCropperRatio: function () {
        var ppData = this.getActivePuzzleData();
        var orientation = this.getSelectedOrientation();

        if (orientation == 'horizontal') {
            this.cropper.setAspectRatio(ppData.width / ppData.height);
        }
        else {
            this.cropper.setAspectRatio(ppData.height / ppData.width);
        }


        // Ajout du masque coeur si le puzzle sélectionné correspond
        if (ppData.id == 106226) {
            this.$cropperWrapper.find('.cropper-face')
                .removeClass('horizontal vertical')
                .addClass('heart ' + orientation);
        }
        else {
            this.$cropperWrapper.find('.cropper-face').removeClass('heart horizontal vertical');
        }

    },

    activeDisabledButtons: function () {
        this.$page.find('button[disabled]').prop('disabled', false);
        this.$page.find('.accordion-head.disabled').removeClass('disabled').trigger('click');
    },

    setImportImageListener: function () {
        var $this = this;


        $('#file_upload').fileupload({
            url: $('#file_upload').attr('action'),
            dataType: 'json',
            autoUpload: true,
            acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
            maxFileSize: 20000000, // 20 Mo
            messages: {
                maxNumberOfFiles: 'Vous avez uploadé trop de fichiers',
                acceptFileTypes: 'Vous ne pouvez mettre que des images au format JPG',
                maxFileSize: 'Fichier trop grand',
                minFileSize: 'Fichier trop petit'
            }
        })
        // A la sélection d'un élément à uploader, on affiche la barre de progression
            .on('fileuploadadd', function (e, data) {
                $this.$img.cropper('destroy');
                $this.$img.hide();

                $this.$placeholderDiv.hide();
                $this.$progressDiv.show();
            })

            // Au début du process, on vérifie si le fichier a été invalidé par le script
            // Si c'est le cas, on affiche le message d'erreur
            .on('fileuploadprocessalways', function (e, data) {
                var index = data.index,
                    file = data.files[index];
                if (file.error) {
                    alert(file.error);

                    $this.$progressDiv.hide();
                    $this.$progressDiv.find('progress').attr('value', 0);
                    $this.$placeholderDiv.show();
                }
            })
            // On met à jour l'état de l'avancement
            .on('fileuploadprogressall', function (e, data) {
                var progress = parseInt(data.loaded / data.total * 100, 10);
                $this.$progressDiv.find('progress').attr('value', progress);
            })
            // A la fin du chargement, on charge l'étape suivante.
            .on('fileuploaddone', function (e, data) {
                $this.originalImageURL = data.result.files[0].callUrl;
                $this.idPhoto = data.result.files[0].idPhoto;
                $this.prepareUploadedImage();
            })
            // A l'échec on l'annulation du chargement, on réinitialise l'affichage.
            // A l'échec on l'annulation du chargement, on réinitialise l'affichage.
            .on('fileuploadfail', function (e, data) {
                $this.$progressDiv.hide();
                $this.$progressDiv.find('progress').attr('value', 0);
                $this.$placeholderDiv.show();
            })

    },

    prepareUploadedImage: function () {
        var $this = this;

        $.post('/websvc/uploadpp_add.ws.php', {
            'idPhoto': $this.idPhoto,
            'random': Math.random(),
        })
            .done(function (data, status, xhr) {
                $this.imageInfos = data;

                $this.$progressDiv.hide();
                $this.$img.show();
                $this.displayImage();
            })
            .fail(function () {
                alert(__('pp_js_errformat'));
            });

    },

    displayImage: function () {
        var $this = this;
        $this.$img[0].src = this.originalImageURL;

        // $this.imageInfos.width = $this.$img[0].naturalWidth;
        // $this.imageInfos.height = $this.$img[0].naturalHeight;

        $this.activeDisabledButtons();

        $this.initCropper();
    },


    editDisplayedActivePuzzleInfos: function () {

        var ppData = this.getActivePuzzleData();

        $('.puzzle-libelle').html(ppData.libelle);
        $('.puzzle-width').html(ppData.width);
        $('.puzzle-height').html(ppData.height);
        var $newPrice = $('.title .new-price');
        var $oldPrice = $('.title .old-price');
        var $promo = $('.title .promotion');

        var newPrice = ppData.salePrice.toString().split('.');
        $newPrice.html(__('devise.prix', newPrice[0], newPrice[1]));

        if (ppData.oldPrice && ppData.oldPrice > ppData.salePrice) {
            var oldPrice = ppData.oldPrice.toString().split('.');
            $oldPrice
                .html(__('devise.prix', oldPrice[0], oldPrice[1]))
                .removeClass('d-none');

            $promo.find('.flag').html('-' + ppData.promo + '%');
            $promo.removeClass('d-none');
        }
        else {
            $oldPrice.addClass('d-none');
            $promo.addClass('d-none');
        }

        // Remplacement de l'URL du navigateur par la nouvelle
        window.history.pushState('', $('title').text(), ppData.phpfile);

    },

    getActivePuzzleData: function () {
        return $('.accordion-model .puzzle-personnalise-button.active').data();
    },

    getSelectedOrientation: function () {
        return $('.accordion-orientation .puzzle-personnalise-button.active').data('orientation');
    },


    updateCoordinates: function (event) {
        this.selectionInfos.width = event.detail.width;
        this.selectionInfos.height = event.detail.height;
        this.selectionInfos.startX = event.detail.x;
        this.selectionInfos.startY = event.detail.y;

        this.updateQualityIndicator();
    },


    validImageSelection: function () {
        var $this = this;

        $.post('/websvc/uploadpp_recadre.ws.php', {
            idPhoto: $this.idPhoto,
            quality: $('.product-details .star-rating').data('quality'),
            random: Math.random(),
            locx: $this.selectionInfos.startX,
            locy: $this.selectionInfos.startY,
            locw: $this.selectionInfos.width,
            loch: $this.selectionInfos.height,
        })
            .done(function (data, status, xhr) {
                // console.log('DONE');
                // console.info(data);

                popin.open(data.html);

                var $popin = $(popin.selector);

                $popin.on('click', 'button.btn', function (e) {
                    e.preventDefault();
                    $this.addToCart();
                    // $('#page-popin').fadeOut(200).remove();
                });


                if ($popin.find('.small-image-alert').length > 0) {
                    $('.star-rating-clone').html($('.accordion-photo .star-rating').clone());
                }

                // // Redirection
                // $('#page-popin').remove();
                //
                // $('body').append(data.html);
                // // .on('click', 'button.seeCheckout', function (e) {
                // //     e.preventDefault();
                // //     window.location = '/caddie/';
                // // })
                // // .on('click', 'button.backToProducts', function (e) {
                // //     e.preventDefault();
                // //     $('#page-popin').fadeOut(200).remove();
                // // })
                // $('#page-popin')
                //     .on('click', 'button.btn', function (e) {
                //         e.preventDefault();
                //         console.log('CLICK');
                //         $this.addToCart();
                //         // $('#page-popin').fadeOut(200).remove();
                //     })
                //     .on('click', 'div.close-popin > a', function (e) {
                //         e.preventDefault();
                //         $('#page-popin').fadeOut(200).remove();
                //     });
                //
                // if ($('#page-popin .small-image-alert').length > 0) {
                //     $('.star-rating-clone').html($('.accordion-photo .star-rating').clone());
                // }


            })
        // var sid = selsid;
        // var req = '/websvc/uploadpp_recadre.ws.php?sid='+sid+'&csid='+csid+'&random='+Math.random()+'&locx='+locx+'&locy='+locy+'&locw='+locw+'&loch='+loch;
        // $('#divimagecrop').empty();
        // $('#divimagecheck').empty();
        // $('#div_pp_encours').html($('.templates .prepa_html').html());
        // pp_encours();
        // jQuery.ajax({
        //     url:    req,
        //     success: function(result) {
        //         // pp_encours_fin();
        //         if (result!='') {
        //             selsid=result;
        //             uploadpp_mesImages(); //uploadpp_selectPP(0);
        //             $('#div_pp_view').html($('.templates .prepa_html').html());
        //             pp_apercu();
        //             var apsize='';
        //             var max = 500;
        //             if (locw>loch) {
        //                 apsize='width="'+max+'px"';
        //             } else {
        //                 apsize='height="'+max+'px"';
        //             }
        //             $('#div_pp_view').html(
        //                 '<img '+apsize+' src="/puzzlesperso/'+csid+'/'+selsid+'.jpg" alt="apercu"/>'
        //                 + $('.templates .view_html').html()
        //             );
        //         } else {
        //             alert(__('pp_js_erreur'));
        //         }
        //     },
        //     async:   true
        // });

    },


    // updateCoordinates: function (c) {
    //     locx = c.x;
    //     locy = c.y;
    //     locw = c.w;
    //     loch = c.h;
    //     this.updateQualityIndicator();
    //     setMasque();
    // },

    updateQualityIndicator: function () {
        var ppData = this.getActivePuzzleData();
        var orientation = this.getSelectedOrientation();
        var imageFullVsThumbRatio = this.imageInfos.width / this.imageInfos.fullWidth;

        // Calcul du DPI minimum
        minWidthDPI = 72;
        minHeightDPI = 72;
        if (ppData.width > 46) minWidthDPI = 60;
        if (ppData.width > 70) minWidthDPI = 55;
        if (ppData.width > 90) minWidthDPI = 45;
        if (ppData.height > 46) minHeightDPI = 60;
        if (ppData.height > 70) minHeightDPI = 55;
        if (ppData.height > 90) minHeightDPI = 45;


        // Calcul de la largeur minimum
        var minWidth0 = (ppData.width / 2.54) * minWidthDPI;
        var minWidth = 0;
        if (this.imageInfos.fullWidth > 0) {
            minWidth = minWidth0 * imageFullVsThumbRatio;
        }
        minWidth = Math.round(minWidth);


        // Calcul de la hauteur minimum
        var minHeight0 = (ppData.height / 2.54) * minHeightDPI;
        var minHeight = 0;
        if (this.imageInfos.fullHeight > 0) {
            minHeight = minHeight0 * imageFullVsThumbRatio;
        }
        minHeight = Math.round(minHeight);


        // Définition des tailles minimum en fonction de l'orientation sélectionnée par l'utilisateur
        if (orientation === "vertical") {
            this.minimumSize.width = minHeight;
            this.minimumSize.height = minWidth;
        } else {
            this.minimumSize.width = minWidth;
            this.minimumSize.height = minHeight;
        }


        // Calcul de la qualité de la photo
        var quality = 10;
        for (var i = 0; i < 9; i++) {
            if (this.selectionInfos.width < (this.minimumSize.width * ((i + 1) / 4))
                ||
                this.selectionInfos.height < (this.minimumSize.height * ((i + 1) / 4))
            ) {
                quality = 1 + i;
                break;
            }
        }

        var isDecimal = quality % 2 !== 0;
        quality = quality / 2;


        $('.product-details .star-rating').data('quality', quality);

        // Affichage de la qualité sur les étoiles
        var $stars = $('.product-details .star-rating .star');
        // On retire toutes les classes
        $stars.removeClass('full mid empty');
        // On attribue la classe "full" à toutes les étoiles avant l'indice de qualité
        $stars.filter(':lt(' + Math.floor(quality) + ')').addClass('full');
        // Si la note est "décimale"
        if (isDecimal) {
            // On attribue la classe "mid" à l'étoile correspondant à l'indice de qualité
            $stars.filter(':eq(' + Math.floor(quality) + ')').addClass('mid');
            // On attribue la classe "empty" à toutes les étoiles suivantes
            $stars.filter(':gt(' + Math.floor(quality) + ')').addClass('empty');
        }
        else {
            // On attribue la classe "empty" à toutes les étoiles suivantes
            $stars.filter(':gt(' + (Math.floor(quality) - 1) + ')').addClass('empty');
        }


        // Affichage du texte correpondant à l'indice de qualité
        var $text = $('.product-details [class*="quality-text-"]');
        $text.hide();
        $text.filter('.quality-text-' + Math.ceil(quality)).show();


    },

    addToCart: function () {
        var $this = this;
        var ppData = this.getActivePuzzleData();
        var orientation = this.getSelectedOrientation();

        console.log(ppData);

        $.get("/websvc/additem.ws.php?idproduit=" + ppData.id + "&idphoto=" + $this.idPhoto + "&qte=1&nbencaddie=0&nbstock=100&redir=1&nocache=" + Math.random())
            .done(function (data, status, xhr) {
                document.location.href = '/caddie/';
            });

    },


};


(function ($) {
    puzzlePersonnalisePage.init();
})(jQuery);